import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

// CREATE CASH PAYMENT
export const createCashPayment = createAsyncThunk(
  "payment/cash",
  async ({ bookingId, amount, paymentFor, isPartialPayment = false }, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/payment/cash-request", {
        bookingId,
        amount,
        currency: "INR",
        paymentFor,
        payment_method: "cash",
        isPartialPayment,
      });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Cash payment failed"
      );
    }
  }
);

export const checkCashPaymentStatus = createAsyncThunk(
  "payment/checkCashStatus",
  async (orderId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/payment/${orderId}`);
      return res.data.data; // { status, payment_status }
    } catch (err) {
      return rejectWithValue("Status check failed");
    }
  }
);

// online
export const createOnlinePayment = createAsyncThunk(
  "payment/createOnlinePayment",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post(
        "/api/payment/payment-request",
        payload
      );
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Payment request failed" }
      );
    }
  }
);

// Fetch CAM pending payments (Admin & Accounts Panel)
export const fetchCamPendingPayments = createAsyncThunk(
  "payment/fetchCamPending",
  async ({ page = 1, limit = 20 } = {}, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/payment/cam/pending?page=${page}&limit=${limit}`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch CAM pending payments"
      );
    }
  }
);
